import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchLiquidacionesListaSellers } from '../../../../actions/sellersActions';
import { 
    fetchEstadosLiquidaciones, 
    fetchResultadosLiquidaciones,
    limpiarLiquidacionesBusqueda,
    setFiltroLiquidaciones
} from '../../../../actions/LiquidacionesActions';
import { 
    putConfirmaNovedad,
    putEliminaNovedadFinal,
    getLiquidacionesListaSellers,
    getEstadosLiquidaciones,
    putEditaNovedadImporte
} from '../../../../api/axios';
import { EstiloCombos, DropDownArrow, customStyle } from '../../../../template/CustomStyle';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import NovedadesListItems from './NovedadesListItems';
import { filtroMedioMes } from '../../../../utilities/fechasFiltro';
import { limpiarFiltros } from '../../../../actions/generalActios';
import BigSpinner from '../../../General/BigSpinner';
const fechaFiltro = filtroMedioMes();

// Wrapper para usar hooks en class component
function ListNovedadesWrapper(props) {
  const navigate = useNavigate();
  return <ListNovedades {...props} navigate={navigate} />;
}


class ListNovedades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lista_sellers_liquidaciones: [],
            lista_estados_liquidaciones: [],
            seller: { 
                label: this.props.filtro?.seller?.label ?? "", 
                value: this.props.filtro?.seller?.value ?? ""
            },
            estado: { 
                label: this.props.filtro?.estado?.label ?? "", 
                value: this.props.filtro?.estado?.value ?? ""
            },
            fechaDesde: this.props.filtro?.fechaDesde ?? fechaFiltro.desde,
            fechaHasta: this.props.filtro?.fechaHasta ?? fechaFiltro.hasta,
            buscaTodo: this.props.filtro?.buscaTodo ?? true,
            ordenDeReferencia: {
                label: this.props.filtro?.ordenDeReferencia?.label ?? "", 
                value: this.props.filtro?.ordenDeReferencia?.value ?? ""
            }

        };
        this.INITIAL_REQUEST = {
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            seller: { label: "", value: "" },
            estado: { label: "", value: "" },
            ordenDeReferencia: { label: "", value: "" },
            buscaTodo: true,
            cantidadPagina: 10,
            numeroPagina: 1
        };
    };

    componentDidMount() {
        if (this.props.liquidaciones?.length > 0) {
            return;
        }
        
        if (this.props.isFilterClear) {
            this.buscarSinFiltro();
        } else {
            this.buscarConFiltro();
        }
    }

    
    buscarSinFiltro = () => {
        this.props.fetchResultadosLiquidaciones({...this.INITIAL_REQUEST, buscaTodo: 1});
        this.props.setFiltroLiquidaciones({...this.INITIAL_REQUEST});
    }

    buscarConFiltro = () => {        
        let filtroParams = {
            fechaDesde: this.props.filtro?.fechaDesde,
            fechaHasta: this.props.filtro?.fechaHasta,
            seller: this.props.filtro?.seller,
            estado: this.props.filtro?.estados,
            buscaTodo: this.props.filtro?.buscaTodo === true ? 1 : 0
        }
        
        this.props.fetchResultadosLiquidaciones(filtroParams);

        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, liquidaciones: false });
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value  });
    }

   
    onChangeCheckbox = async (e) => {
        const { name, checked } = e.target;
        this.setState({ [name]: checked } );
        this.props.setFiltroLiquidaciones({
            ...this.props.filtroLiquidaciones,
            [name]: checked
        });
        
    }


    onSubmit = async (event) => {

        event.preventDefault();

        const { fechaDesde, fechaHasta, buscaTodo, seller, estado } = this.state

        if (fechaDesde == "") {
            toast.warn("Debe seleccionar una fecha inicial");
            return;
        }

        if (fechaHasta == "") {
            toast.warn("Debe seleccionar una fecha final");
            return;
        }

        let setFiltroParams = {
            fechaDesde: fechaDesde,
            fechaHasta: fechaHasta,
            seller: this.state.seller,
            estado: this.state.estado,
            ordenDeReferencia: this.state.ordenDeReferencia,
            buscaTodo: buscaTodo
            
        }
        
        this.props.setFiltroLiquidaciones(setFiltroParams)

        let request = {
            fechaDesde: fechaDesde,
            fechaHasta: fechaHasta
        }


        if (buscaTodo) {
            request.buscaTodo = 1;
            request.idSeller = 0;
            request.idEstado = 0;
            request.ordenDeReferencia = 0;
        } else {
            
            if (seller.value == "") {
                toast.warn("Seleccione un Seller");
                return;
            }

            if (estado.value == "") {
                toast.warn("Seleccione un estado");
                return;
            }
            
            request.buscaTodo = 0;
            request.idSeller = seller.value;
            request.idEstado = estado.value;
            request.ordenDeReferencia = request.ordenDeReferencia == "" ? 0 : request.ordenDeReferencia;
        }

        this.props.limpiarLiquidacionesBusqueda();
        this.props.fetchResultadosLiquidaciones(request);
        this.setLimpiarFiltroFalse();
    }


    onClear = (e) => {
        const { buscaTodo } = this.state
        e.preventDefault(); 
        this.setState(prevState => ({
            ...prevState,
            ...this.INITIAL_REQUEST
        }));
        this.buscarSinFiltro();
    };

    confirmarNovedades = (idNovedades) => {
        
        let data = {id: idNovedades};
        let post = putConfirmaNovedad(data);

        post.then(res => {
            document.getElementById("botonBuscar").click();
            toast.success("La novedades fueron confirmadas con exito");
            return;
        }).catch(err => {
            toast.error("No pudimos confirmar la novedad");
        });
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ seller: valor });
    }


    selectSearchHandlerLiquidacionesEstado = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ estado: valor });
    }

    editarNovedad = (idNovedad, nuevoImporte) => {

        let datos = {idNovedad: idNovedad, Importe: nuevoImporte}
        let post = putEditaNovedadImporte(datos);

        post.then(res => {
            document.getElementById("botonBuscar").click();
            toast.success("El importe fue actualizado con exito.");
            return;
        }).catch(err => {
            toast.error("No pudimos editar el importe de esta novedad");
        });
    }

    eliminarNovedad = (idNovedad) => {

        let datos = {
            idsNovedades: [parseInt(idNovedad, 10)]
        };

        let post = putEliminaNovedadFinal(datos);

        post.then(res => {
            document.getElementById("botonBuscar").click();
            toast.success("El novedad fue eliminada con exito.");
            return;
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudimos eliminar la novedad");
        });
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ seller: valor });
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ estado: valor });
    }

    goToNuevaNovedad = () => {
        this.props.navigate("/Novedades/Nueva");
    }

    mapSellers = () => {
        getLiquidacionesListaSellers().then(res => {
            let listaTipo = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            })
            this.setState({ lista_sellers_liquidaciones: listaTipo });
        });
    }

    mapEstados = () => {

        getEstadosLiquidaciones().then(res => {
            let listaEstados = res.listadoEstadosNovedades.map((tipo) => {
                return {label: tipo.descripcion, value: tipo.idEstado.toString()};
            })
            this.setState({listaTipoEstados: listaEstados})
        })
    }


    render() {
    
        let tipoVal = null;
        let listaTipo = [];
        if (this.props.lista_sellers_liquidaciones != undefined) {
            this.props.lista_sellers_liquidaciones.map((tipo) => {
                if (tipo.codigo == this.props.lista_sellers_liquidaciones.codigo) {
                    tipoVal = { label: tipo.descripcion, value: tipo.codigo.toString() }
                }
                listaTipo.push({ label: tipo.razonSocial, value: tipo.codigo.toString() })
            })
        }
      
        let tipoValEstados = null;
        let listaTipoEstados = [];
        if (this.props.lista_estados_liquidaciones != undefined) {
            this.props.lista_estados_liquidaciones.map((tipo) => {
                if (tipo.idEstado == this.props.lista_estados_liquidaciones.idEstado) {
                    tipoValEstados = { label: tipo.descripcion, value: tipo.idEstado.toString() }
                }
                listaTipoEstados.push({ label: tipo.descripcion, value: tipo.idEstado.toString() })
            })
        }

        let liquidaciones = !Array.isArray(this.props.liquidaciones) ? [] : this.props.liquidaciones;

        return (
            <div className="container">
                <div className="row justify-content-between">
    
                    <div className="col-12 col-md-7">
                        <h4 className="text-themecolor color-rojo-megatone">Gestión de Novedades</h4>
                    </div>

                    <div className="col-12 col-md-2 text-end">
                        <button 
                            onClick={this.goToNuevaNovedad} 
                            type="button" 
                            className="btn btn-sm btn-green"
                        >
                            <i className="fa fa-plus-circle"/> Crear Novedad
                        </button>
                    </div>
    
                    <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit} onReset={this.onClear}>
                        <div className="card">
                            <div className="card-body p-4">

                                <div className="row justify-content-between">
                                    <div className="col-12 col-md-2 d-inline-block">

                                        <p className="font-bold">Desde</p>
                                        <input 
                                            type="date" 
                                            className="form-control" 
                                            name="fechaDesde" 
                                            onChange={this.myChangeHandler}
                                            value={this.state.fechaDesde}
                                        />
                                    </div>
    
                                    <div className="col-12 col-md-2 d-inline-block">

                                        <p className="font-bold">Hasta</p>
                                        <input 
                                            type="date" 
                                            name="fechaHasta" 
                                            className="form-control" 
                                            onChange={this.myChangeHandler}
                                            value={this.state.fechaHasta}
                                        />
                                    </div>
    
                                    <div className="col-12 col-md-2 d-inline-block">

                                        <p className="font-bold">Seller</p>
                                        <Select
                                            value={this.state.seller}
                                            options={this.state.lista_sellers_liquidaciones}
                                            onChange={this.selectSearchHandlerLiquidacionesSeller}
                                            onMenuOpen={this.mapSellers}
                                            styles={customStyle}
                                            components={{ DropdownIndicator: () => DropDownArrow }}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 d-inline-block">

                                        <p className="font-bold">Estados</p>
                                        <Select
                                            value={this.state.estado}
                                            options={this.state.listaTipoEstados}
                                            onChange={this.selectSearchHandlerLiquidacionesEstado}
                                            onMenuOpen={this.mapEstados}
                                            styles={customStyle}
                                            components={{ DropdownIndicator: () => DropDownArrow }}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 d-inline-block">
                                        
                                        <p className="font-bold">Orden De Referencia</p>
                                        <input 
                                            type="number" 
                                            className="form-control"
                                            name="ordenDeReferencia" 
                                            min={0}
                                            onChange={this.myChangeHandler}
                                            value={this.state.ordenDeReferencia}
                                        />
                                    </div>

                                    <div className="col-12 col-md-8 d-inline-block mt-4">

                                        <input 
                                            name="buscaTodo"
                                            type="checkbox" 
                                            className="mx-2"
                                            onChange={this.onChangeCheckbox}
                                            checked={this.state.buscaTodo}
                                        />
                                        <label htmlFor="buscaTodo">
                                            Todas las novedades de todos los sellers en el rango de tiempo
                                        </label>
                                    </div>

                                     <div className="col-12 col-sm-6 text-center text-sm-end mt-sm-3">
                                        <button
                                            type="submit"
                                            id="botonBuscar"
                                            className="btn btn-sm background-rojo-megatone"
                                            disabled={this.props.isLoadingLiquidaciones}
                                        >
                                            Buscar
                                        </button>

                                        <button
                                            type="reset"
                                            id="botonReset"
                                            className="btn btn-sm btn-grey ms-2 ms-sm-2 mt-2 mt-sm-0"
                                            disabled={this.props.isLoadingLiquidaciones}
                                        >
                                            Limpiar
                                        </button>
                                    </div>

                                    
                                </div>
                            </div>
                        </div>
                    </form>

                    {
                        this.props.isLoadingLiquidaciones ? (

                            <div className="d-flex justify-content-center">
                                <BigSpinner />
                            </div>

                        ) : liquidaciones.length === 0 ? (

                            <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                                NO SE ENCONTRARON RESULTADOS
                            </h5>

                        ) : (

                             <NovedadesListItems
                                liquidaciones={liquidaciones}
                                confirmarNovedadesFunction={this.confirmarNovedades}
                                editarNovedadFunction={this.editarNovedad}
                                eliminarNovedadFunction={this.eliminarNovedad}
                            />
                        )
                    }

                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    isLoadingLiquidaciones: state.liquidaciones.isLoadingLiquidaciones,
    liquidaciones: state.liquidaciones.lista_resultados_liquidaciones,
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    lista_estados_liquidaciones: state.liquidaciones.lista_estados_liquidaciones,
    filtro: state.liquidaciones.filtro,
    emptyFilters: state.general.limpiar,
    isFilterClear: state.general.limpiar.liquidaciones,
});

export default connect(mapStateToProps, { 
    limpiarLiquidacionesBusqueda,
    fetchLiquidacionesListaSellers, 
    fetchResultadosLiquidaciones,
    fetchEstadosLiquidaciones,
    setFiltroLiquidaciones,
    limpiarFiltros
}) (ListNovedadesWrapper);